import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { IllustrationIf, ResultIllustrationInfo } from '../interfaces/IllustrationIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C501IllustrationGetProps {
  execIllustrationGet: (deviceId: string) => Promise<ResultIllustrationInfo>
  loading: loadStatus
}
// C501 図解一覧取得API呼出
export const useC501IllustrationGet = (): C501IllustrationGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execIllustrationGet = async (deviceId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.get(
        buildDeviceUrl(deviceId, apiUrl.illustrationsPath),
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        if (response.data !== '') {
          const infos: IllustrationIf[] = response.data.map((illustration: IllustrationIf) => {
            return {
              ...illustration,
              storage_path: String(illustration.storage_path!),
              full_storage_path: String(illustration.full_storage_path!),
            }
          })
          // console.log(infos);
          setLoading(loadStatus.LOADED)
          return { success: true, info: infos }
        }
        const infos: IllustrationIf[] = []
        setLoading(loadStatus.LOADED)
        return { success: true, info: infos }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execIllustrationGet, loading }
}
